<div
  [class]="'table-header-select-wrapper ' + name"
  [attr.data-filter-name]="name"
  class="table-header-select-menu"
>
  <mat-select
    #selectField
    [(ngModel)]="model"
    [required]="isRequired"
    [multiple]="isMultiple"
    [disabled]="isDisabled"
    [placeholder]="labelPrefix + label"
    (openedChange)="searchText = ''"
    (ngModelChange)="onModelChange()"
    (closed)="onPanelClosed()"
    (opened)="keepData = false"
    panelClass="table-header-select"
    disableOptionCentering
  >
    @if (isInTableHeader) {
      <mat-select-trigger class="input-filter-header">
        {{ label }}
        @if (model?.length > 0) {
          <span>({{ model.length }})</span>
        }
      </mat-select-trigger>
    }
    <div class="select-input-search">
      <input placeholder="Search" matInput [(ngModel)]="searchText" />
    </div>
    <div class="selection-container">
      <button type="button" mat-button color="primary" (click)="selectAll()">
        Select all
      </button>
      <button type="button" mat-button color="primary" (click)="deselectAll()">
        Deselect all
      </button>
    </div>
    @for (item of list | search: searchText; track $index) {
      <mat-option
        [hidden]="item.hidden == true || (hideMarked && item.marked == true)"
        [value]="item.id"
        >{{ item.name }}</mat-option
      >
    }
    @if (hasNullFilter) {
      <mat-option
        value=""
        class="null-option"
        (click)="nullOnly(); selectField.close()"
        >NULL</mat-option
      >
    }
    <div class="selection-container bottom-buttons">
      <button
        type="button"
        mat-flat-button
        color="primary"
        (click)="onOKClick(); selectField.close()"
      >
        OK
      </button>
      <button
        type="button"
        mat-button
        (click)="onPanelCloseOrCancel(); selectField.close()"
      >
        Cancel
      </button>
    </div>
  </mat-select>
</div>
